import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './css/Navbar.css';
import crownLogo from '../img/crown/ChatGPT Image Dec 11, 2025, 12_53_45 PM.png';


const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isGalleryDropdownOpen, setIsGalleryDropdownOpen] = useState(false);
    const location = useLocation();

    const getBulbCount = () => {
        const width = window.innerWidth;

        if (width >= 1600) return 26;   // 1920+
        if (width >= 1200) return 20;   // laptops
        if (width >= 992) return 16;    // tablets landscape
        if (width >= 768) return 12;    // tablets
        if (width >= 480) return 8;     // phones
        return 6;                       // small phones
    };

    const [bulbCount, setBulbCount] = useState(getBulbCount());

    useEffect(() => {
        const handleResize = () => {
            setBulbCount(getBulbCount());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        document.body.classList.toggle('menu-open', !isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
        setIsGalleryDropdownOpen(false);
        document.body.classList.remove('menu-open');
    };

    const toggleGalleryDropdown = () => {
        setIsGalleryDropdownOpen(!isGalleryDropdownOpen);
    };

    const isActiveLink = (path: string) => {
        return location.pathname === path;
    };

    const isGalleryActive = () => {
        return location.pathname === '/gallery' ||
            location.pathname === '/gallery2' ||
            location.pathname === '/gallery3';
    };

    useEffect(() => {
        closeMenu();
    }, [location]);

    useEffect(() => {
        return () => {
            document.body.classList.remove('menu-open');
        };
    }, []);

    const handleLinkClick = () => {
        closeMenu();
    };

    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closeMenu();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, []);

    return (
        <nav className="navbar">
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={closeMenu}>
                    <img
                        src={crownLogo}
                        alt="Crown Residence Logo"
                        className="navbar-logo-image"
                    />
                </Link>

                <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
                    <li className="navbar-item">
                        <Link
                            to="/"
                            className={`navbar-link ${isActiveLink('/') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            НҮҮР
                        </Link>
                    </li>
                    <li className="navbar-item">
                        <Link
                            to="/gallery"
                            className={`navbar-link ${isActiveLink('/gallery') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            А БЛОК
                        </Link>
                    </li>
                    <li className="navbar-item">
                        <Link
                            to="/gallery2"
                            className={`navbar-link ${isActiveLink('/gallery2') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            Б БЛОК
                        </Link>
                    </li>
                    <li className="navbar-item">
                        <Link
                            to="/gallery3"
                            className={`navbar-link ${isActiveLink('/gallery3') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            С БЛОК
                        </Link>
                    </li>

                    {/* <li className="navbar-item">
                        <Link
                            to="/timeline"
                            className={`navbar-link ${isActiveLink('/timeline') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            timeline
                        </Link>
                    </li> */}

                    <li className="navbar-item">
                        <Link
                            to="/about"
                            className={`navbar-link ${isActiveLink('/about') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            ТӨСЛИЙН ТАЛААР
                        </Link>
                    </li>
                    <li className="navbar-item">
                        <Link
                            to="/contact"
                            className={`navbar-link ${isActiveLink('/contact') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            ХОЛБОО БАРИХ
                        </Link>
                    </li>
                    <li className="navbar-item">
                        <Link
                            to="/partners"
                            className={`navbar-link ${isActiveLink('/partners') ? 'active' : ''}`}
                            onClick={handleLinkClick}
                        >
                            Хамтрагчид
                        </Link>
                    </li>
                </ul>

                <button
                    className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                    aria-expanded={isMenuOpen}
                >
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </button>
            </div>
            {/* <div className="christmas-lights">
                {Array.from({ length: bulbCount }).map((_, i) => (
                    <LightBulb key={i} />
                ))}
            </div> */}
        </nav>
    );
};
const LightBulb: React.FC = () => {

    const getRandomColor = (exclude?: string) => {
        const BULB_COLORS = [
            'warmwhite',
            'yellow',
            'amber',
            'red',
            'green',
            'blue',
            'cyan',
            'purple',
            'pink'
        ];
        const available = BULB_COLORS.filter(c => c !== exclude);
        return available[Math.floor(Math.random() * available.length)];
    };


    const [color, setColor] = useState(() => getRandomColor());

    useEffect(() => {
        const scheduleNextChange = () => {
            const timeout = setTimeout(() => {
                setColor(prev => getRandomColor(prev));
                scheduleNextChange();
            }, 3000 + Math.random() * 6000);

            return timeout;
        };

        const timeoutId = scheduleNextChange();

        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <span className="light-wrapper">
            <span className="rope-segment" />
            <span className={`light ${color}`} />
        </span>
    );
};


export default Navbar;